module.exports = __webpack_public_path__ + "assets/img/33_167_big.5092cf64.jpg";